import { useAuth } from "../hooks/useAuth"

export function LoginPage() {
  const { signIn } = useAuth()

  const handleSignIn = async () => {
    try {
      await signIn()
    } catch (error: any) {
      // 사용자가 인증 창을 닫은 경우는 에러로 처리하지 않음
      if (error?.message !== "Auth window closed") {
        console.error("로그인 오류:", error)
      }
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-amber-100 flex items-center justify-center px-4 sm:px-6">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-6 sm:p-8">
        <div className="text-center mb-6 sm:mb-8">
          <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-3 sm:mb-4 flex items-center justify-center">
            <img 
              src="https://static.lumi.new/a6/a63d536d75bc6d80fe8261fd7f08abe8.webp" 
              alt="Pavetech Logo" 
              className="w-16 h-16 sm:w-20 sm:h-20 object-contain"
            />
          </div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
            업무 관리 포털
          </h1>
          <p className="text-sm sm:text-base text-gray-600">
            페이브텍 주요 업무 관리 시스템
          </p>
        </div>

        <div className="space-y-4 sm:space-y-6">
          <div className="bg-orange-50 border border-orange-200 rounded-lg p-3 sm:p-4">
            <p className="text-xs sm:text-sm text-orange-800">
              <strong>안내:</strong> Lumi 플랫폼 로그인을 통해 인증합니다.
              <br />
              회원가입 후 관리자의 승인이 필요합니다.
            </p>
          </div>

          <button
            onClick={handleSignIn}
            className="w-full bg-gradient-to-r from-orange-600 to-amber-600 text-white py-2.5 sm:py-3 px-4 rounded-lg text-sm sm:text-base font-semibold hover:from-orange-700 hover:to-amber-700 transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            로그인
          </button>

          <div className="text-center text-xs sm:text-sm text-gray-500">
            <p>관리자 계정: pavetech@pavetech.co.kr</p>
          </div>
        </div>
      </div>
    </div>
  )
}
